function Home() {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <p className="text-sm text-gray-400">Select a department from the sidebar to get started.</p>
    </div>
  );
}

export default Home;
